var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import './sizebuttons.css';
var style = function (theme) { return ({
    btn: {
        display: 'inline-block',
        textDecoration: 'none',
        color: '#668ad8',
        width: '120px',
        height: '120px',
        lineHeight: '120px',
        borderRadius: '50%',
        border: 'solid 2px #668ad8',
        textAlign: 'center',
        verticalAlign: 'middle',
        overflow: 'hidden',
        fontWeight: 'bold',
        transition: '.4s',
    }
}); };
var SizeButtons = /** @class */ (function (_super) {
    __extends(SizeButtons, _super);
    function SizeButtons() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SizeButtons.prototype.render = function () {
        var styles = {
            btn: {
                display: 'inline-block',
                // color: 'black',
                backgroundColor: 'transparent',
                width: this.props.size || '50px',
                height: this.props.height || '45px',
                lineHeight: this.props.size || '40px',
                fontSize: this.props.fontSize || '24px',
                // margin: '2%',
                padding: '1.5%',
                zoom: 1
            }
        };
        return (React.createElement("a", { onClick: this.props.setSize, style: styles.btn, className: 'mobile_btn' },
            this.props.Csize,
            " "));
    };
    return SizeButtons;
}(Component));
export default SizeButtons;



//////////////////
// WEBPACK FOOTER
// ./src/components/sizeButtons/mobileSizeButtons.tsx
// module id = 1401
// module chunks = 0 1 2 3 4 5